import './App.css'; 
import Navmenu from './Components/Navbar/navmenu';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'; 
import Accueil from './Pages/accueil';
import Promo from './Pages/promo';
import Contact from './Pages/contact';
import Login from './Pages/login';
import Register from './Pages/register';
import CartItems from './Components/CartItems/CartItems';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/ReactToastify.css';

import { useCart } from './Context/CartContext';
import ProductPage from './Pages/products';
import CategoriesProducts from './Pages/categoriesProducts';
import Checkout from './Pages/checkout';
import CompteClient from './Pages/compteClient';
import ConfirmationCommande from './Pages/confirmationCommande';
import EchecPaiement from './Pages/echecPaiement';

import PackPage from './Pages/PackPage';

import Footer from './Components/Footer/footer';
import './Components/Styles/accueil.css'

import ScrollToTop from './Components/Scroll/ScrollToTop';

function AppContent() {
  const { addToCart } = useCart();
  const location = useLocation();
  const hideFooterOn = ['/compteClient', '/login', '/produit'];
  const currentPath = location.pathname.replace(/\/$/, '');
  const shouldShowFooter = !hideFooterOn.some(path => currentPath.startsWith(path));

  return (
    <div className='home-page'>
      <ScrollToTop />
      <Navmenu />
      <Routes> 
        <Route path='/' element={<Accueil/>}/>
        <Route path="/categorie/:categoryName" element={<CategoriesProducts />} />
        <Route path="/produit/:productId" element={<ProductPage addToCart={addToCart} />} />
        <Route path='/promo' element={<Promo/>}/>
        <Route path='/contact' element={<Contact/>}/>
        <Route path='/Login' element={<Login/>}/>
        <Route path='/Register' element={<Register/>}/>
        <Route path='/CartItems' element={<CartItems/>}/>
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/compteClient" element={<CompteClient />} />
        <Route path="/confirmationCommande" element={<ConfirmationCommande />} />
        <Route path="/echecPaiement" element={<EchecPaiement />} />
        <Route path="/pack/:packId" element={<PackPage />} />
      </Routes>
      <ToastContainer />
      {shouldShowFooter && <Footer />}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  )
}
  

export default App;